import links from "./links"

const pagesToTranslate = [
  "b2b-payments",
  "digital-banking-platform",
  "growth-and-activation",
  "cryptocurrency",
  "embedded-finance",
  "investing-and-cash-management",
  "data-and-analytics",
  "contact-us",
  "clients",
  "careers",
  "events",
  "podcast",
  "about",
  "blog",
  "news",
  "risk-and-compliance",
  "/lp/demo-cyberbank-konecta-conversational-ai/",
  "payment-processing-and-money-transfers",
  "deposits-and-banking",
  "credit-and-lending",
  "konecta-overview-ai-powered-virtual-banking-assistan",
  "card-issuing",
  "customer-service-and-ivr",
  "program-management",
  "dispute-operations",
  "fraud-operations",
  "co-brand-debit",
  "cloud-infrastructure",
  "galileo-open-apis",
  "banking-core",
  "trusted-partners",
  "/privacy-disclosure/",
  "/privacy-disclosure-california/",
  "american-with-disabilities-act-accessibility",
  "/lp/brochure-cyberbank-core/",
  "/lp/brochure-leading-digital-banks-deliver-differentiated-customer-experiences/",
  "/lp/elevate-customer-engagement-with-conversational-ai/",
  "cyberbank-core",
  "deposits",
  "core-modernization",
  "evolution-lab",
  "buy-now-pay-later",
  "card-issuing",
  "conversational-ai",
  "corporate-credit",
  "cyberbank-digital",
  "cyberbank-konecta",
  "digital-banking",
  "disbursements-and-payouts",
  "instant-verification",
  "parent-teen",
  "payment-hub",
  "payment-risk-platform",
  "secured-credit",
  "who-we-serve",
]
const differentUrlForTranslation = {
  "/lp/demo-cyberbank-konecta-conversational-ai/":
    "/lp/demo-cyberbank-konecta-ia-conversacional/",
  "/lp/konecta-overview-ai-powered-virtual-banking-assistant/":
    "/lp/resumen-de-konecta-asistente-bancario-virtual-impulsado-por-ia",
  "/lp/brochure-cyberbank-core/": "/lp/folleto-cyberbank-core",
  "/lp/brochure-leading-digital-banks-deliver-differentiated-customer-experiences/":
    "/lp/folleto-los-principales-bancos-digitales-ofrecen-experiencias-de-cliente-diferenciadas",
  "/lp/elevate-customer-engagement-with-conversational-ai/":
    "/lp/mejore-la-participaci%C3%B3n-de-los-clientes-con-la-inteligencia-artificial-conversacional",
}

type Section = {
  title: string
  left?: boolean
  links: {
    title: string
    url: string
  }[]
}

type RoutesForHeader = {
  deposits: Section[]
  channels: Section[]
  payments_and_cards: Section[]
  lending: Section[]
  risk: Section[]
  platforms: Section[]
  company: Section[]
}

export const routesForHeader: RoutesForHeader = {
  deposits: [
    {
      title: "Products",
      left: true,
      links: [
        {
          title: "Cyberbank Core",
          url: "/deposits/cyberbank-core/",
        },
        {
          title: "Deposits",
          url: "/deposits/",
        },
      ],
    },
    {
      title: "Use Cases",
      left: false,
      links: [
        {
          title: "Core Modernization",
          url: "/deposits/use-case/core-modernization/",
        },
      ],
    },
    {
      title: "Services",
      left: false,
      links: [
        {
          title: "Evo Lab",
          url: "/services/evolution-lab/",
        },
        {
          title: "Customer Service/IVR",
          url: "/services/customer-service-and-ivr/",
        },
      ],
    },
    {
      title: "Featured Product",
      links: [
        {
          title: "Cyberbank Core",
          url: "/deposits/cyberbank-core/",
        },
      ],
    },
  ],
  channels: [
    {
      title: "Products",
      left: true,
      links: [
        {
          title: "Cyberbank Digital",
          url: "/channels/cyberbank-digital/",
        },
        {
          title: "Cyberbank Konecta",
          url: "/channels/cyberbank-konecta/",
        },
      ],
    },
    {
      title: "Use Cases",
      left: false,
      links: [
        {
          title: "Digital Banking",
          url: "/channels/use-case/digital-banking/",
        },
        {
          title: "Conversational AI",
          url: "/channels/use-case/conversational-ai/",
        },
      ],
    },
    {
      title: "Services",
      left: false,
      links: [
        {
          title: "Evo Lab",
          url: "/services/evolution-lab/",
        },
        {
          title: "Customer Service/IVR",
          url: "/services/customer-service-and-ivr/",
        },
      ],
    },
    {
      title: "Featured Product",
      links: [
        {
          title: "Cyberbank Digital",
          url: "/channels/cyberbank-digital/",
        },
      ],
    },
  ],
  payments_and_cards: [
    {
      title: "Products",
      left: true,
      links: [
        {
          title: "Card Issuing",
          url: "/payments-and-cards/card-issuing/",
        },
        {
          title: "Payment Hub",
          url: "/payments-and-cards/payment-hub/",
        },
        // {
        //   title: "Prepaid Card",
        //   url:'/payments-and-cards/prepaid-card/'
        // }
      ],
    },
    {
      title: "Use Cases",
      left: false,
      links: [
        {
          title: "Parent/Teen",
          url: "/payments-and-cards/use-case/parent-teen/",
        },
        {
          title: "Co-Brand Debit",
          url: "/services/co-brand-debit/",
        },
        {
          title: "Disbursements/ Payouts",
          url: "/payments-and-cards/use-case/disbursements-and-payouts/",
        },
      ],
    },
    {
      title: "Services",
      left: false,
      links: [
        {
          title: "Customer Service/IVR",
          url: "/services/customer-service-and-ivr/",
        },
        {
          title: "Program Management",
          url: "/services/program-management/",
        },
        {
          title: "Disputes",
          url: "/services/dispute-operations/",
        },
      ],
    },
    {
      title: "Featured Product",
      links: [
        {
          title: "Card Issuing",
          url: "/payments-and-cards/card-issuing/",
        },
      ],
    },
  ],
  lending: [
    {
      title: "Products",
      left: true,
      links: [
        {
          title: "Secured Credit",
          url: "/lending/secured-credit/",
        },
        {
          title: "Corporate Credit",
          url: "/lending/corporate-credit/",
        },
        {
          title: "Buy Now Pay Later",
          url: "/lending/buy-now-pay-later/",
        },
        {
          title: "Cyberbank Core",
          url: "/deposits/cyberbank-core/",
        },
      ],
    },
    {
      title: "Use Cases",
      left: false,
      links: [
        {
          title: "Secured Card",
          url: "/news/galileo-launches-secured-credit-with-dynamic-funding/",
        },
        {
          title: "BNPL: Pre-Purchase",
          url: "/blog/where-does-buy-now-pay-later-fit-in-the-future-of-banking/",
        },
        {
          title: "BNPL: Post-Purchase",
          url: "/news/galileo-launches-bnpl-post-purchase-for-credit-and-debit/",
        },
      ],
    },
    {
      title: "Services",
      left: false,
      links: [
        {
          title: "Customer Service/IVR",
          url: "/services/customer-service-and-ivr/",
        },
        {
          title: "Program Management",
          url: "/services/program-management/",
        },
        {
          title: "Disputes",
          url: "/services/dispute-operations/",
        },
      ],
    },
    {
      title: "Featured Product",
      links: [
        {
          title: "Secured Credit",
          url: "/lending/secured-credit/",
        },
      ],
    },
  ],
  risk: [
    {
      title: "Products",
      left: true,
      links: [
        {
          title: "Payment Risk Platform",
          url: "/risk/payment-risk-platform/",
        },
        {
          title: "Instant Verification Engine",
          url: "/risk/instant-verification/",
        },
      ],
    },
    {
      title: "Use Cases",
      left: false,
      links: [
        {
          title: "Fraud Management",
          url: "/blog/balancing-fraud-prevention-customer-experience/",
        },
        // {
        //   title: "Instant Verification",
        //   url: "/risk/use-case/instant-verification/",
        // },
      ],
    },
    {
      title: "Services",
      left: false,
      links: [
        {
          title: "Fraud Operations",
          url: "/services/fraud-operations/",
        },
        {
          title: "Disputes",
          url: "/services/dispute-operations/",
        },
      ],
    },
    {
      title: "Featured Product",
      links: [
        {
          title: "Instant Verification Engine",
          url: "/risk/instant-verification/",
        },
      ],
    },
  ],
  platforms: [
    {
      title: "Developers",
      left: true,
      links: [
        {
          title: "Docs",
          url: links.programApi,
        },
        {
          title: "Sandbox",
          url: links.apiSandbox,
        },
        {
          title: "Open APIs",
          url: "/platform/open-apis/",
        },
      ],
    },
    {
      title: "Ecosystem",
      left: false,
      links: [
        {
          title: "Trusted Partners",
          url: "/platform/trusted-partners/",
        },
        {
          title: "Trusted Clients",
          url: "/platform/trusted-clients/",
        },
      ],
    },
    {
      title: "Who We Serve",
      left: true,
      links: [
        {
          title: "Financial Institutions",
          url: "/platform/who-we-serve/#fis/",
        },
        {
          title: "Fintechs",
          url: "/platform/who-we-serve/#fintechs/",
        },
        {
          title: "Brands",
          url: "/platform/who-we-serve/#brands/",
        },
      ],
    },
    {
      title: "Featured Product",
      links: [
        {
          title: "Sandbox",
          url: links.apiSandbox,
        },
      ],
    },
  ],
  company: [
    {
      title: "About",
      left: true,
      links: [
        {
          title: "About Us",
          url: "/about/",
        },
        {
          title: "Careers",
          url: "/careers/",
        },
        {
          title: "Contact Us",
          url: "/contact-us/",
        },
      ],
    },
    {
      title: "Resources",
      left: false,
      links: [
        {
          title: "Blog",
          url: "/blog/",
        },
        {
          title: "Newsroom",
          url: "/news/",
        },
        {
          title: "Podcast",
          url: "/podcast/",
        },
        {
          title: "Events",
          url: "/events/",
        },
      ],
    },
    {
      title: "Featured Product",
      links: [
        {
          title: "Podcast",
          url: "/podcast/",
        },
      ],
    },
  ],
}
const routes = {
  deposits: [
    {
      title: "Deposits",
      url: "/deposits/",
    },
    {
      title: "Cyberbank Core",
      url: "/deposits/cyberbank-core/",
    },
    {
      title: "Core Modernization",
      url: "/deposits/use-case/core-modernization/",
    },
  ],
  channels: [
    {
      title: "Cyberbank Digital",
      url: "/channels/cyberbank-digital/",
    },
    {
      title: "Digital Banking",
      url: "/channels/use-case/digital-banking/",
    },
    {
      title: "Cyberbank Konecta",
      url: "/channels/cyberbank-konecta/",
    },
    {
      title: "Conversational AI",
      url: "/channels/use-case/conversational-ai/",
    },
  ],
  payments_and_cards: [
    {
      title: "Card Issuing",
      url: "/payments-and-cards/card-issuing/",
    },
    {
      title: "Payment Hub",
      url: "/payments-and-cards/payment-hub/",
    },
    // {
    //   title: "Debit Issuing",
    //   url: "/payments-solutions/growth-and-activation/",
    // },
    {
      title: "Co-Brand Debit",
      url: "/services/co-brand-debit/",
    },
    {
      title: "Disbursements/ Payouts",
      url: "/payments-and-cards/use-case/disbursements-and-payouts/",
    },
    {
      title: "Parent/Teen",
      url: "/payments-and-cards/use-case/parent-teen/",
    },
  ],
  lending: [
    {
      title: "Secured Credit",
      url: "/lending/secured-credit/",
    },
    {
      title: "Corporate Credit",
      url: "/lending/corporate-credit/",
    },
    {
      title: "Buy Now Pay Later",
      url: "/lending/buy-now-pay-later/",
    },
  ],
  risk: [
    {
      title: "Payment Risk Platform",
      url: "/risk/payment-risk-platform/",
    },
    {
      title: "Instant Verification",
      url: "/risk/instant-verification/",
    },
    // {
    //   title: "Fraud Operations",
    //   url: "/services/fraud-operations/",
    // },
  ],
  solutions: [
    {
      title: "Banking",
      url: "/payments-solutions/digital-banking-platform/",
    },
    {
      title: "B2B Payments",
      url: "/payments-solutions/b2b-payments/",
    },
    {
      title: "Growth & Activation",
      url: "/payments-solutions/growth-and-activation/",
    },
    {
      title: "Cryptocurrency",
      url: "/payments-solutions/cryptocurrency/",
    },
    {
      title: "Embedded Finance",
      url: "/payments-solutions/embedded-finance/",
    },
    {
      title: "Investing",
      url: "/payments-solutions/investing-and-cash-management/",
    },
  ],
  products: [
    {
      title: "Cards",
      url: "/products/card-issuing/",
    },
    {
      title: "Deposits",
      url: "/deposits/",
    },
    {
      title: "Payments & Transfers",
      url: "/products/payment-processing-and-money-transfers/",
    },
    {
      title: "Credit & Lending",
      url: "/products/credit-and-lending/",
    },
    {
      title: "Data & Analytics",
      url: "/products/data-and-analytics/",
    },
    {
      title: "Risk & Compliance",
      url: "/products/risk-and-compliance/",
    },
    {
      title: "Conversational AI",
      url: "/lp/demo-cyberbank-konecta-conversational-ai/",
    },
  ],
  platform: [
    {
      title: "Cloud Infrastructure",
      url: "/platform/cloud-infrastructure/",
    },
    {
      title: "API Technology",
      url: "/platform/galileo-open-apis/",
    },
    {
      title: "Banking Core",
      url: "/platform/banking-core/",
    },
    {
      title: "Trusted Partners",
      url: "/platform/trusted-partners/",
    },
  ],
  platforms: [
    {
      title: "Docs",
      url: links.programApi,
    },
    {
      title: "Sandbox",
      url: links.apiSandbox,
    },
    {
      title: "Open APIs",
      url: "/platform/open-apis/",
    },
    {
      title: "Trusted Partners",
      url: "/platform/trusted-partners/",
    },
    {
      title: "Trusted Clients",
      url: "/platform/trusted-clients/",
    },
  ],
  developers: [
    {
      title: "API Documentation",
      url: links.programApi,
    },
    {
      title: "Guides",
      url: links.guides,
    },
    {
      title: "Recipes",
      url: links.recipes,
    },
    {
      title: "Change Log",
      url: links.changeLog,
    },
    {
      title: "Sandbox",
      url: links.apiSandbox,
    },
  ],
  company: [
    {
      title: "About Us",
      url: "/about/",
    },
    // {
    //   title: "Clients",
    //   url: "/clients/",
    // },
    {
      title: "Careers",
      url: "/careers/",
    },
    {
      title: "Contact Us",
      url: "/contact-us/",
    },
    {
      title: "Events",
      url: "/events/",
    },
    {
      title: "Newsroom",
      url: "/news/",
    },
    {
      title: "Blog",
      url: "/blog/",
    },
    {
      title: "Podcast",
      url: "/podcast/",
    },
  ],
  services: [
    {
      title: "Fraud Operations",
      url: "/services/fraud-operations/",
    },
    {
      title: "Disputes Operations",
      url: "/services/dispute-operations/",
    },
    {
      title: "Program Management",
      url: "/services/program-management/",
    },
    {
      title: "Customer Service",
      url: "/services/customer-service-and-ivr/",
    },
    {
      title: "Evolution Lab",
      url: "/services/evolution-lab/",
    },
  ],
  legal: [
    {
      url: "#",
      title: "Cookie Preferences",
    },
    { url: "/privacy-disclosure/", title: "Privacy Disclosure" },
    {
      url: "/american-with-disabilities-act-accessibility/",
      title: "ADA Accessibility",
    },
  ],
}
interface TranslationURLS {
  [key: string]: any
}
// export const checkedLocaleLink = (url: string, lang: string) => {
//   const pageIsIncluded = pagesToTranslate.filter(page => url.includes(page))
//   // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
//   const URL = (differentUrlForTranslation as TranslationURLS)[url]
//   if (URL) {
//     // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
//     return pageIsIncluded.length > 0 && lang !== "en" ? `/${lang}${URL}` : url
//   }
//   return pageIsIncluded.length > 0 && lang !== "en" ? `/${lang}${url}` : url
// }

export const checkedLocaleLink = (url: string, lang: string) => {
  const pageIsIncluded = pagesToTranslate.filter(page => url.includes(page))
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const URL = (differentUrlForTranslation as TranslationURLS)[url]

  if (URL && lang === "es") {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return pageIsIncluded.length > 0 ? `/${lang}${URL}` : url
  }

  if (lang === "pt") {
    return pageIsIncluded.length > 0 ? `/${lang}${url}` : url
  }

  return pageIsIncluded.length > 0 && lang !== "en" ? `/${lang}${url}` : url
}

export const returnContactUsLink = (lang: string) => {
  return checkedLocaleLink("/contact-us/", lang)
}

export default routes
